import { render } from "./AppSideNav.vue?vue&type=template&id=1dc35f67&scoped=true"
import script from "./AppSideNav.vue?vue&type=script&lang=js"
export * from "./AppSideNav.vue?vue&type=script&lang=js"

import "./AppSideNav.vue?vue&type=style&index=0&id=1dc35f67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc35f67"]])

export default __exports__